import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EpicService {
  constructor(private api: ApiService) {}

  getAllEpics(data: any): Observable<any> {
    return this.api.post(environment.getAllEpics, data);
  }

  createEpic(data: any): Observable<any> {
    return this.api.post(environment.createEpic, data);
  }

  updateEpic(data: any): Observable<any> {
    return this.api.post(environment.updateEpic, data);
  }

  deleteEpic(data: any): Observable<any> {
    return this.api.post(environment.deleteEpic, data);
  }

  getEpicById(data: any): Observable<any> {
    return this.api.post(environment.getEpicById, data);
  }

  getProjectHierarchy(data: any): Observable<any> {
    return this.api.post(environment.getProjectHierarchy, data);
  }
}
